module.exports = __webpack_public_path__ + "static/media/github-select-release.85ebaa3f.png";